import { Color } from '../enums/color.enum';
import { Theme, ThemeType } from './Theme.model';

export const THEMES: Record<ThemeType, Theme> = {
  enTheme: {
    '--main-color': Color.BLUE,
    '--main-color-hover': Color.BLUE_HOVER,
    '--main-color-active': Color.BLUE_ACTIVE,
    '--text-color': Color.WHITE,
    '--second-color': Color.PINK,
    '--second-color-hover': Color.PINK_HOVER,
    '--second-color-active': Color.PINK_ACTIVE,
    '--focused-border-color': Color.LIGHT_BLUE,
    '--link-color': Color.LIGHT_BLUE,
    '--link-color-hover': Color.LIGHT_BLUE_HOVER,
    '--link-color-active': Color.LIGHT_BLUE_HOVER,
    '--third-color': Color.BLUE,
    '--third-color-hover': Color.BLUE_HOVER,
    '--third-color-active': Color.BLUE_ACTIVE,
    '--table-gradient': Color.TABLE_GRADIENT,
    '--secondary-button-hover': Color.BLUE,
    '--tech-tugs-bg': Color.LIGHT_BLUE3,
    '--tech-tugs-border': Color.LIGHT_BLUE30,
    '--bg-color-second': Color.DARK_BLUE,
    '--vacancies-filter-bg': Color.TRANSPARENT,
    '--label-text-color': Color.LIGHT_BLUE,
    '--scrollbar-drag': Color.BLUE,
    '--arrow-link-hover': Color.BLUE,
    '--bullet-color': Color.BLUE,
  },
  uzTheme: {
    '--main-color': Color.ORANGE,
    '--main-color-hover': Color.ORANGE_HOVER,
    '--main-color-active': Color.ORANGE_ACTIVE,
    '--text-color': Color.BLACK,
    '--second-color': Color.TURQUOISE,
    '--second-color-hover': Color.TURQUOISE_HOVER,
    '--second-color-active': Color.TURQUOISE_ACTIVE,
    '--focused-border-color': Color.TURQUOISE,
    '--link-color': Color.CORAL,
    '--link-color-hover': Color.CORAL_HOVER,
    '--link-color-active': Color.CORAL_ACTIVE,
    '--third-color': Color.BRICK,
    '--third-color-hover': Color.BRICK_HOVER,
    '--third-color-active': Color.BRICK,
    '--table-gradient': Color.TABLE_GRADIENT2,
    '--secondary-button-hover': Color.CORAL,
    '--tech-tugs-bg': Color.CORAL3,
    '--tech-tugs-border': Color.CORAL30,
    '--bg-color-second': Color.BRICK,
    '--vacancies-filter-bg': Color.BRICK,
    '--label-text-color': Color.WHITE,
    '--scrollbar-drag': Color.TURQUOISE,
    '--arrow-link-hover': Color.BORDO,
    '--bullet-color': Color.BRICK_HOVER,
  },
};
